import { DashboardPageStyled } from "./dashboard.page.styled";
import PageTemplateComponent from "../../../../components/page-template/page-template.component";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { getUser } from "../../../../utils/get-user.util";
import { RoleEnum } from "../../../../enums/role.enum";
import { Box, Typography } from "@mui/material";

const DashboardPage = observer(() => {

    const user = useMemo(() => getUser(), []);

    const greeting = "Bine ai venit";

    const firstName = user?.firstName || user?.fullName?.split(' ')[0] || '';

    const roleMessage = useMemo(() => {
        const roles = user?.roles || [];

        if (roles.includes(RoleEnum.Admin)) {
            return {
                description: "Ai acces complet la toate sectiunile aplicatiei. Poti gestiona produsele, comenzile, partenerii, utilizatorii si tot ce tine de buna functionare a platformei.",
                suggestions: [
                    { label: "Comenzi", path: "/app/comenzi", description: "Vezi si gestioneaza comenzile primite" },
                    { label: "Produse", path: "/app/produse", description: "Adauga sau modifica produsele din catalog" },
                    { label: "Parteneri", path: "/app/partneri", description: "Gestioneaza partenerii si punctele de livrare" },
                    { label: "Utilizatori interni", path: "/app/utilizatori-interni", description: "Administreaza conturile echipei" },
                ]
            };
        }

        if (roles.includes(RoleEnum.Production)) {
            return {
                description: "Esti in zona de productie. De aici poti urmari comenzile si gestiona procesele de productie si transare.",
                suggestions: [
                    { label: "Comenzi", path: "/app/comenzi", description: "Vezi comenzile care trebuie pregatite" },
                    { label: "Proces de productie", path: "/app/item-receipts", description: "Urmareste si actualizeaza productia" },
                    { label: "Proces de transare", path: "/app/slice-process", description: "Gestioneaza procesul de transare" },
                ]
            };
        }

        if (roles.includes(RoleEnum.Order)) {
            return {
                description: "Esti in zona de comenzi si livrari. Poti gestiona comenzile si urmari activitatea din platforma.",
                suggestions: [
                    { label: "Comenzi", path: "/app/comenzi", description: "Vezi si gestioneaza comenzile" },
                    { label: "Loguri", path: "/app/logs", description: "Consulta istoricul activitatilor" },
                ]
            };
        }

        return {
            description: "Selecteaza o sectiune din meniul din stanga pentru a incepe.",
            suggestions: []
        };
    }, [user]);

    return (
        <DashboardPageStyled>
            <PageTemplateComponent title="Dashboard">
                <Box sx={{ maxWidth: 700, py: 2 }}>
                    <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>
                        {greeting}, {firstName}!
                    </Typography>

                    <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4, lineHeight: 1.7 }}>
                        {roleMessage.description}
                    </Typography>

                    {roleMessage.suggestions.length > 0 && (
                        <>
                            <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 2 }}>
                                De unde vrei sa incepi?
                            </Typography>

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                {roleMessage.suggestions.map((item) => (
                                    <Box
                                        key={item.path}
                                        onClick={() => window.location.href = item.path}
                                        sx={{
                                            p: 2,
                                            borderRadius: 2,
                                            border: '1px solid',
                                            borderColor: 'divider',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s',
                                            '&:hover': {
                                                borderColor: 'primary.main',
                                                backgroundColor: 'action.hover',
                                            }
                                        }}
                                    >
                                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                            {item.label}
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                            {item.description}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        </>
                    )}
                </Box>
            </PageTemplateComponent>
        </DashboardPageStyled>
    )

})

export default DashboardPage;
